var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.theHasAccess)?_c('b-button',{staticClass:"kst-button",class:_vm.theClass,attrs:{"disabled":_vm.disabled,"href":_vm.theHref,"icon-left":_vm.theIconLeft,"label":_vm.theLabel,"rounded":_vm.rounded,"tag":_vm.theTag,"target":_vm.theTarget,"to":_vm.theTo},on:{"click":_vm.handleClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }